// styles.ts
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import {COLORS} from "shared/consts";

export const AnalyticsParent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
`;

export const AnalyticsHeader = styled.div`
    display: flex;
    gap: 14px;
    overflow: auto;
    width: 100%;
    align-items: center;
    
    @media screen and (max-width: 1000px) {
        height: 44px;

        .segmentedcontrol {
            height: 100%;
        }
    }
`;

export const AnalyticsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    
    @media screen and (max-width: 1000px) {
        padding-bottom: 60px;
    }
`;

const spanByFrac = (f: number) => {
    if (f <= 0.25) return 3;
    if (f <= 1 / 3) return 4;
    return 6;
};

export const Row = styled.div<{ itemCount: number; rowKind: "top" | "bottom" }>`
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 16px;
    min-height: 328px;

    @media (max-width: 1480px) {
        grid-template-columns: repeat(6, 1fr);
    }
    
    @media screen and (max-width: 1000px) {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: column;
        gap: 16px;
    }

    ${(p) =>
            p.rowKind === "top" &&
            css`
                --frac: ${p.itemCount >= 4 ? 0.25 : p.itemCount === 3 ? 0.3334 : 0.5};
            `}
    ${(p) =>
            p.rowKind === "bottom" &&
            css`
                --frac: ${Math.min(0.5, 1 / Math.max(1, p.itemCount))};
            `}
}

`;

export const AnalyticsArea = styled.div<{ frac?: number }>`
    border-radius: 16px;
    padding: 16px 16px 16px 16px;
    background: var(--bg-surface1, #fff);
    min-height: 220px;
    grid-column: span ${(p) => spanByFrac(p.frac ?? 0.5)};
    display: flex;
    flex-direction: column;

    @media (max-width: 1480px) {
        //flex: 1 1 calc(50% - 16px);
        grid-column: .5;
        //max-width: calc(50% - 16px);
    }

    @media (max-width: 1480px) {
        &:last-child:nth-child(odd) {
            flex-basis: 100%;
            max-width: 100%;
        }
    }

    @media (max-width: 1000px) {
        flex: 1 1 100%;
        max-width: 100%;
        max-height: max-content;
    }
`;

export const AnalyticHeader = styled(Link)`
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    min-height: 20px;
    height: max-content;

    svg {
        width: 20px;
        height: 20px;
    }

    h4 {
        color: var(--fg-default, rgba(16, 24, 40, 1));
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        margin-left: 4px;
        margin-right: auto;
    }
`;

export const AnalyticRightCol = styled.div`
    display: flex;
    gap: 0;
    align-items: center;

    p {
        color: var(--fg-muted, rgba(16, 24, 40, 0.55));
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
    }

    svg {
        width: 24px;
        height: 24px;
    }
`;

export const HiddenRow = styled.div`
    display: none;
`;

export const DateInputInSegmentWrapper = styled.div`
    .input {
        min-height: 28px !important;
    }
    &.active .input {
        background: ${COLORS.BG.SURFACE1};
    }
`;

export const AnalyticBody = styled.div`
    display: flex;
    gap: 32px;
    margin-bottom: auto;
`;

export const AnalyticBodyCol = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const AnalyticBodyColTitle = styled.div`
    color: var(--fg-soft, rgba(16, 24, 40, 0.75));
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
`;

export const AnalyticBodyColValueText = styled.div<{ $status?: "red" | "yellow" | "green" }>`
    position: relative;
    display: flex;
    gap: 4px;
    align-items: flex-end;
    width: max-content;

    strong {
        color: var(--fg-default, rgba(16, 24, 40, 1));
        font-size: 24px;
        font-weight: 700;
        line-height: 24px;
    }

    span {
        color: var(--fg-default, rgba(16, 24, 40, 1));
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        padding-bottom: 1px;
    }

    ${(p) =>
            p.$status &&
            css`
                &:after {
                    content: "";
                    position: absolute;
                    right: -4px;
                    bottom: 6px;
                    border-radius: 50%;
                    transform: translateX(100%);
                    width: 6px;
                    height: 6px;
                    background: var(--badge-primary-success-bg-color);
                }
            `}

    ${(p) =>
            p.$status === "green" &&
            css`
                &:after {
                    background: var(--badge-primary-success-bg-color);
                }
            `}

    ${(p) =>
            p.$status === "yellow" &&
            css`
                &:after {
                    background: yellow;
                }
            `}

    ${(p) =>
            p.$status === "red" &&
            css`
                &:after {
                    background: red;
                }
            `}
`;
